import getRecipientsCount from './getRecipientsCount';
export function isViewStateDirty(context) {
    return (context.isDirty ||
        (context.toRecipientWell && context.toRecipientWell.isDirty) ||
        (context.ccRecipientWell && context.ccRecipientWell.isDirty) ||
        (context.bccRecipientWell && context.bccRecipientWell.isDirty));
}
export function getTotalRecipientCount(context) {
    return (getRecipientsCount(context.toRecipientWell) +
        getRecipientsCount(context.ccRecipientWell) +
        getRecipientsCount(context.bccRecipientWell));
}
/* Group may have been removed from recipients since creating a group compose view state.
Check to see if the view state still contains the group as a recipient */
export function viewStateHasGroupIdAsRecipient(groupComposeViewState) {
    // Short circuit this evaluation by first checking for Reply All operation,
    // since group cannot be removed from recipients in that scenario
    return (groupComposeViewState.operation == 2 /* ReplyAll */ ||
        groupComposeViewState.toRecipientWell.recipients.some(function (recipient) {
            return (recipient.persona.EmailAddress.EmailAddress.toLowerCase() ===
                groupComposeViewState.groupId.toLowerCase());
        }));
}
//# sourceMappingURL=viewStateUtils.js.map